import { useCallback, useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';
import { Schema } from '../_types/schema.types';

export const useSchemaLoader = () => {
  console.log('useSchemaLoader - Hook initialized');
  
  const [isSchemaLoaded, setIsSchemaLoaded] = useState(false);
  const [schemaData, setSchemaData] = useState<Schema | null>(() => {
    const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
    if (schema && schema.authenticationType) {
      console.log('useSchemaLoader - Initial schema loaded:', schema);
      setIsSchemaLoaded(true);
      return schema;
    }
    return null;
  });

  const checkSchemaLoaded = useCallback(() => {
    console.log('useSchemaLoader - checkSchemaLoaded called');
    const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
    if (schema && schema.authenticationType) {
      console.log('useSchemaLoader - Schema is loaded:', schema);
      setSchemaData(schema);
      setIsSchemaLoaded(true);
      return true;
    }
    return false;
  }, []);

  const waitForSchema = useCallback(async (maxAttempts: number = 20): Promise<Schema | null> => {
    console.log('useSchemaLoader - waitForSchema called');
    
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      if (schema && schema.authenticationType) {
        console.log('useSchemaLoader - Schema loaded successfully on attempt:', attempt + 1);
        setSchemaData(schema);
        setIsSchemaLoaded(true);
        return schema;
      }
      
      console.log('useSchemaLoader - Attempt', attempt + 1, 'of', maxAttempts, '- Schema not ready yet');
      
      // Aguardar 250ms antes da próxima tentativa
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    
    console.error('useSchemaLoader - Failed to load schema after', maxAttempts, 'attempts');
    return null;
  }, []);

  const getAuthenticationType = useCallback((): string => {
    console.log('useSchemaLoader - getAuthenticationType called');
    // Sempre ler diretamente do localStorage para garantir valor atualizado
    const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
    const authType = schema?.authenticationType?.toLowerCase() || 'password';
    console.log('useSchemaLoader - getAuthenticationType:', authType);
    return authType;
  }, []);

  return {
    isSchemaLoaded,
    schemaData,
    waitForSchema,
    getAuthenticationType,
    checkSchemaLoaded
  };
}; 